import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchAccountDynamicFieldLists } from '../../../actions/parent/accountConfigurations/fetch';
import AccountDynamicFieldListsPage from '../../../components/body/parentSettings/configurations/AccountDynamicFieldListsPage';

const AccountDynamicFieldListsContainer: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchAccountDynamicFieldLists());
  }, [dispatch]);

  return <AccountDynamicFieldListsPage />;
};

export default AccountDynamicFieldListsContainer;
